export default __webpack_public_path__ + "static/media/ExerciseIllustration.cdd7b93c.svg";